import i18n from "i18n/config";
import { Outlet, RouteObject } from "react-router-dom";

export const internalTemplateRoutes: RouteObject[] = [
  {
    id: "eventing",
    path: "eventing",
    children: [
      {
        id: "eventingIndex",
        path: "",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalEventingPage } = await import(
            "features/internal/template/InternalEventingPage"
          );
          return { Component: InternalEventingPage };
        },
        children: [
          {
            id: "templateImportTab",
            path: "imports",
            lazy: async () => {
              const { InternalTemplateImportTab } = await import(
                "features/internal/template/tabs/InternalTemplateImportTab"
              );
              return { Component: InternalTemplateImportTab };
            },
            handle: {
              title: i18n.t("internal:templateImports"),
            },
          },
          {
            id: "templateLoadTab",
            path: "loads",
            lazy: async () => {
              const { InternalTemplateLoadTab } = await import(
                "features/internal/template/tabs/dashboard/InternalTemplateLoadTab"
              );
              return { Component: InternalTemplateLoadTab };
            },
            handle: {
              title: i18n.t("internal:customerLoads"),
            },
          },
          {
            id: "templateExportTab",
            path: "exports",
            lazy: async () => {
              const { InternalTemplateExportTab } = await import(
                "features/internal/template/tabs/dashboard/InternalTemplateExportTab"
              );
              return { Component: InternalTemplateExportTab };
            },
            handle: {
              title: i18n.t("internal:customerExports"),
            },
          },
        ],
      },
    ],
  },
  {
    id: "eventTemplate",
    path: "eventing/:templateVersionId/template",
    element: <Outlet />,
    children: [
      {
        id: "template",
        path: "",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalTemplatePage } = await import(
            "features/internal/template/InternalTemplatePage"
          );
          return { Component: InternalTemplatePage };
        },
      },
      {
        id: "templateExport",
        path: ":templateImportExportId/export",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalTemplateExportPage } = await import(
            "features/internal/template/InternalTemplateExportPage"
          );
          return { Component: InternalTemplateExportPage };
        },
        children: [
          {
            id: "exportTemplateTab",
            path: "template",
            lazy: async () => {
              const { InternalTemplateExportTemplateTab } = await import(
                "features/internal/template/tabs/export/InternalTemplateExportTemplateTab"
              );
              return { Component: InternalTemplateExportTemplateTab };
            },
            handle: {
              title: i18n.t("internal:template"),
            },
          },
          {
            id: "exportEventsTab",
            path: "events",
            lazy: async () => {
              const { InternalTemplateExportRecordTab } = await import(
                "features/internal/template/tabs/export/InternalTemplateExportRecordTab"
              );
              return { Component: InternalTemplateExportRecordTab };
            },
            handle: {
              title: i18n.t("internal:exportedEvents"),
            },
          },
        ],
      },
      {
        id: "templateLoad",
        path: ":templateImportExportId/load",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalTemplateLoadPage } = await import(
            "features/internal/template/InternalTemplateLoadPage"
          );
          return { Component: InternalTemplateLoadPage };
        },
      },
      {
        id: "templateEvent",
        path: ":templateEventId/event/:viewOrEdit",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalTemplateEventPage } = await import(
            "features/internal/template/InternalTemplateEventPage"
          );
          return { Component: InternalTemplateEventPage };
        },
      },
      {
        id: "templateExportRecord",
        path: ":templateExportRecordId/record",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalTemplateExportRecordPage } = await import(
            "features/internal/template/InternalTemplateExportRecordPage"
          );
          return { Component: InternalTemplateExportRecordPage };
        },
      },
    ],
  },
];
